module.exports = __webpack_public_path__ + "img/mining-bg2.5f006790.png";